import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ShieldCheckIcon } from 'lucide-react';
export function InnerIntentionsPrivacyPage() {
  return <div className="min-h-screen bg-[#0a0014] text-white pt-28 pb-24 overflow-hidden relative" data-id="element-1144" data-mp="2pj695dplg4dl">
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-fuchsia-600/20 rounded-full blur-[120px] pointer-events-none" data-id="element-1145" data-mp="2ui9e6y5kqalk" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-pink-600/20 rounded-full blur-[120px] pointer-events-none" data-id="element-1146" data-mp="2gqbe1ctubp1j" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1147" data-mp="2lkfldx70pz35">
        {/* Back link */}
        <Link to="/apps/inner-intentions" className="inline-flex items-center gap-2 text-fuchsia-300 hover:text-fuchsia-200 font-medium mb-8 transition-colors" data-id="element-1148" data-mp="26rvmx9utcfs1">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-1149" data-mp="1xve6ps7ldrpf" />
          Back to Inner Intentions
        </Link>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12" data-id="element-1150" data-mp="39cfugbjq0xc9">
          <div className="w-14 h-14 rounded-2xl bg-fuchsia-950/50 border border-fuchsia-500/30 flex items-center justify-center mx-auto mb-6 shadow-[0_0_20px_rgba(236,72,153,0.3)]" data-id="element-1151" data-mp="3jb5eoaz3atvo">
            <ShieldCheckIcon className="w-7 h-7 text-fuchsia-300" data-id="element-1152" data-mp="2qloozl2utr35" />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-fuchsia-400 to-purple-400 mb-3 drop-shadow-[0_0_10px_rgba(236,72,153,0.5)]" data-id="element-1153" data-mp="2ln531ko9gfas">
            Privacy Policy
          </h1>
          <p className="text-fuchsia-300/70 font-medium" data-id="element-1154" data-mp="2vkj8kp8nbjob">
            Inner Intentions — Effective May 12, 2026
          </p>
        </motion.div>

        {/* Content */}
        <div className="bg-black/40 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-fuchsia-900/50" data-id="element-1155" data-mp="22xf88xkhztiv">
          <div className="prose prose-invert max-w-none text-fuchsia-100/70 text-sm leading-relaxed space-y-6" data-id="element-1156" data-mp="2sjq1acbpv9qg">
            <p data-id="element-1157" data-mp="2wl1sune5i51a">
              Inner Intentions ("we," "our," or "us") respects your privacy and
              is committed to protecting your personal information. This Privacy
              Policy explains how information may be collected, used, and
              protected when using the Inner Intentions mobile application and
              related services.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1158" data-mp="2dmqn25md0in0">
              Information We May Collect
            </h3>
            <p data-id="element-1159" data-mp="2il0kynzgxxcb">Depending on how you use the app, we may collect:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-1160" data-mp="2nly7fcrihdjm">
              <li data-id="element-1161" data-mp="2njbsut67dxrw">Account information such as email address or username</li>
              <li data-id="element-1162" data-mp="3u1if2hflfnvs">Basic profile information</li>
              <li data-id="element-1163" data-mp="2uxthd8b5865">App usage activity and preferences</li>
              <li data-id="element-1164" data-mp="2tmgqnwvwq2w">
                Device information such as device type, operating system, and
                crash reports
              </li>
              <li data-id="element-1165" data-mp="1idvfns97warj">
                Anonymous analytics data used to improve app performance and
                user experience
              </li>
            </ul>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1166" data-mp="1dlc0iquvt7km">
              How We Use Information
            </h3>
            <p data-id="element-1167" data-mp="14njjni9ihrv4">Information collected may be used to:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-1168" data-mp="14obdoongnhja">
              <li data-id="element-1169" data-mp="znnq6cyfxitt">Provide and improve app functionality</li>
              <li data-id="element-1170" data-mp="zq9wk99lhsag">Personalize user experience</li>
              <li data-id="element-1171" data-mp="upvnqp066ebd">Save preferences and progress</li>
              <li data-id="element-1172" data-mp="uqnijxly080l">Monitor app stability and performance</li>
              <li data-id="element-1173" data-mp="pran4oh09sme">Respond to support requests or feedback</li>
              <li data-id="element-1174" data-mp="2p3dfypbirzcq">Prevent abuse, spam, or misuse of the platform</li>
            </ul>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1175" data-mp="2k40hf7bad3ub">
              Data Sharing
            </h3>
            <p data-id="element-1176" data-mp="2s46t0qrugjou">We do not sell personal information to third parties.</p>
            <p data-id="element-1177" data-mp="2x3jdj4v8teo9">
              Some third-party services used by the app, such as analytics,
              authentication, subscriptions, advertising, or cloud hosting
              providers, may process limited data necessary for app
              functionality.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1178" data-mp="2n7gdq5nv5s4h">
              User Content
            </h3>
            <p data-id="element-1179" data-mp="2e4ozxz7imk9o">
              Questions, responses, profile content, and interactions within the
              app may be stored to provide gameplay, social features,
              personalization, or saved progress. Users are responsible for the
              content they choose to share inside the app.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1180" data-mp="1qeunhir3yxpy">
              Children's Privacy
            </h3>
            <p data-id="element-1181" data-mp="1ufencu32gffs">
              Inner Intentions is not directed toward children under the age of
              13. We do not knowingly collect personal information from children
              under 13.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1182" data-mp="16v5ip87tzlti">
              Data Security
            </h3>
            <p data-id="element-1183" data-mp="1kqpuljp573rf">
              We take reasonable measures to help protect user information and
              maintain platform security. However, no system can guarantee
              complete security.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1184" data-mp="1psow0o1bnqlq">
              Account & Data Removal
            </h3>
            <p data-id="element-1185" data-mp="23ia77c8vr1j7">
              Users may request account or data deletion by contacting: <br data-id="element-1186" data-mp="1zhglmpiwtyth" />
              <strong data-id="element-1187" data-mp="1zj1gyhd1tlse">Email:</strong> trippinwithmandy@gmail.com
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1188" data-mp="2dh80stl5xl92">
              Changes to This Policy
            </h3>
            <p data-id="element-1189" data-mp="28k7xurjm0ym6">
              This Privacy Policy may be updated periodically. Continued use of
              the app after updates constitutes acceptance of the revised
              policy.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1190" data-mp="1a73q1dnptcn0">
              Contact
            </h3>
            <p data-id="element-1191" data-mp="1f3u5pzvly67w">
              For questions regarding this Privacy Policy, contact: <br data-id="element-1192" data-mp="1jxf3bqtagy6k" />
              <strong data-id="element-1193" data-mp="1jxygku7zuye9">Trippin' with Mandy Email:</strong>{' '}
              trippinwithmandy@gmail.com
            </p>
          </div>
        </div>
      </div>
    </div>;
}